import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import BvBadge from 'volta/components/bv-badge';
import BvBtn from 'volta/components/bv-btn';
import BvInline from 'volta/components/bv-inline';
import BvMethodoIcon from 'volta/components/bv-methodo-icon';
import CodeDesc from 'volta/components/code-desc';

import type { TOC } from '@ember/component/template-only';
import type { TPlanningMethodology, TReorderStrategy } from 'volta/models/types/planning-settings';

interface TasksKitListSkuPayloadSignature {
  Args: {
    id: string;
    payload: {
      methodology?: TPlanningMethodology;
      isProtected?: boolean;
      reorderStrategy?: TReorderStrategy;
      partCode: string;
      description: string;
      acqCode: string;
    };
  };
  Element: HTMLElement;
}

const TasksKitListSkuPayloadComponent: TOC<TasksKitListSkuPayloadSignature> = <template>
  <BvBtn @route='protected.sku' @routeModel={{@id}} @subtle={{true}} @size='sm' ...attributes>
    <BvInline @gap='2' @wrap={{false}} @blockAlign='center'>
      <BvMethodoIcon
        @methodology={{@payload.methodology}}
        @isProtected={{@payload.isProtected}}
        @reorderStrategy={{@payload.reorderStrategy}}
      />
      <CodeDesc @code={{@payload.partCode}} @desc={{@payload.description}} />
      <BvBadge @text={{t (concat 'acqCodes.' @payload.acqCode)}} />
    </BvInline>
  </BvBtn>
</template>;

export default TasksKitListSkuPayloadComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::List::SkuPayload': typeof TasksKitListSkuPayloadComponent;
    'tasks-kit/list/sku-payload': typeof TasksKitListSkuPayloadComponent;
  }
}
